import {
  QuestionSubmissionDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";
import { useQuery } from "@tanstack/react-query";

import { DOMAIN_FORM_SUBMISSIONS } from "../domain";

import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { submissionsApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_GET_FORM_SUBMISSION = "GET_FORM_SUBMISSION";

const allowedRoles = [
  UserRole.Owner,
  UserRole.Manager,
  UserRole.Respondent,
  UserRole.Viewer,
  UserRole.Auditor,
];

type GetFormSectionSubmission = {
  formId: string;
  sectionId: string;
};

export const fetchFormSectionSubmission = async (
  req: GetFormSectionSubmission,
): Promise<QuestionSubmissionDto[] | undefined> => {
  const response =
    await submissionsApi.submissionsControllerGetFormSectionSubmission(
      req.formId,
      req.sectionId,
    );

  return response.data;
};

export const useGetFormSectionSubmission = (
  user: UserProfileDto | null,
  req: GetFormSectionSubmission,
  enable: boolean = true,
): {
  formSubmission?: QuestionSubmissionDto[];
  formSubmissionEnabled: boolean;
  formSubmissionError: Error | null;
  isLoadingFormSubmission: boolean;
  isFetchingFormSubmission: boolean;
} => {
  const enabled = enable && roleGuard(user, allowedRoles);
  const { data, error, isLoading, isFetching } = useQuery<
    QuestionSubmissionDto[] | undefined,
    Error
  >({
    queryKey: [
      DOMAIN_FORM_SUBMISSIONS,
      ACTION_GET_FORM_SUBMISSION,
      req.formId,
      req.sectionId,
    ],
    queryFn: () => fetchFormSectionSubmission(req),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    formSubmission: data,
    formSubmissionEnabled: enabled,
    formSubmissionError: error,
    isLoadingFormSubmission: isLoading,
    isFetchingFormSubmission: isFetching,
  };
};
